import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetTotalCloseAppointmentDetailsNetwork } from "../../../redux/actions/PayoutAction";
import CustomPagination from "../../../common/CustomPagination";


export const TotalClosedApprointments = ({
  searchFilter,
  providerDetail,
  setProviderDetail,
  setSearchFilter,
  setSelectAllFlag,
  setSelectAll,
  header,
  setheader
}) => {
  const dispatch = useDispatch();
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);

  useEffect(() => {
    dispatch(
      GetTotalCloseAppointmentDetailsNetwork({
        ...searchFilter,
        page: 1,
      })
    );
  }, []);
  console.log(header);
  return (
    <>
      <div className="table-responsive __custom__properties">
        <table className="table">
          <thead>
            <tr className="avanishtbl">
              <th>
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={
                    payoutReducer?.getTotalClosedAppointment?.length ===
                    providerDetail?.length
                  }
                  onClick={(e) => {
                    if (e.target.checked) {
                      setProviderDetail(
                        payoutReducer?.getTotalClosedAppointment
                      );
                      setSelectAllFlag(true);
                    } else {
                      setSelectAll(false);
                      setProviderDetail([]);
                      setSelectAllFlag(false);
                    }
                  }}
                  readOnly
                />
              </th>
              {header
                .filter((ele) => ele?.show === true)
                ?.map((elee) => {
                  return (
                    <th
                      // style={{
                      //   textAlign:
                      //     elee?.label !== "Provider Name" ? "center" : "",
                      // }}
                    >
                      {elee?.label}
                    </th>
                  );
                })}
            </tr>
          </thead>
          {payoutReducer?.getTotalClosedAppointment?.length !== 0 && (
            <tbody>
              {payoutReducer?.getTotalClosedAppointment?.map(
                (ele, itemIndex) => {
                  return (
                    <tr key={itemIndex}>
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={providerDetail.some((item) => ele === item)}
                          onClick={(e) => {
                            if (e.target.checked) {
                              setProviderDetail([...providerDetail, ele]);
                            } else {
                              setSelectAllFlag(false);
                              setSelectAll(false);
                              setProviderDetail(
                                providerDetail?.filter((item) => ele !== item)
                              );
                            }
                          }}
                          readOnly
                        />
                      </td>
                      {header
                        ?.filter((ele) => ele?.show === true)
                        ?.map((coll) => {
                          return (
                            <td
                              // style={{
                              //   textAlign:
                              //     coll?.label !== "Provider Name"
                              //       ? "center"
                              //       : "",
                              // }}
                            >
                              {" "}
                              {
                                <div style={{ width: "170px" }}>
                                  {coll?.label === "Updated Date"
                                    ? ele[coll?.col]?.split("T")[0]
                                    : ele[coll?.col]}
                                </div>
                              }
                            </td>
                          );
                        })}
                    </tr>
                  );
                }
              )}
            </tbody>
          )}
        </table>
        {payoutReducer?.getTotalClosedAppointment?.length === 0 && (
          <p className="noRecordFound">No Record Found</p>
        )}
        <div className="d-flex justify-content-center mt-4">
          {globalReducer?.getTotalCount !== 0 && (
            <CustomPagination
              totalCount={globalReducer?.getTotalCount}
              perPageData={searchFilter?.rows}
              searchFilter={searchFilter}
              setSearchFilter={setSearchFilter}
              apiCall={GetTotalCloseAppointmentDetailsNetwork}
              IsPayoutStatus={false}
            />
          )}
        </div>
           
      </div>
    </>
  );
};
